import styled, { css } from 'styled-components';
import { withPrivacy } from 'components/atoms/private';
const Bar = styled.div``;
export const Primary = styled(Bar)``;
export const Secondary = styled(Bar)``;
export const Central = styled(Bar)``;
export const Hanger = styled(Bar)``;
const ActionBar = styled.div`
  background: var(--action-bar-background);
  display: flex;
  height: var(--rte-action-bar-height);
  overflow: hidden;
  transition: height var(--animation-duration-medium) ease-in;
  align-items: center;
  padding-right: var(--spacing-02);

  ${({ layer })=>layer != null ? css`
          z-index: var(--zindex-layer-${`0${layer}`});
        ` : css`
          z-index: var(--zindex-modal-lowest);
        `}

  & {
    --action-bar-background: transparent;
    --action-bar-height: 2rem;
  }

  ${Primary},
  ${Secondary},
  ${Central} {
    align-items: center;
    display: flex;
    flex: 1;
  }

  ${Primary} {
    justify-content: flex-start;
  }

  ${Secondary} {
    justify-content: flex-end;
  }

  ${Central} {
    justify-content: center;
  }

  ${Bar} .ant-btn-icon-only,
  ${Bar} .rl-btn-only-icon {
    width: 2rem;
    min-width: 2rem;
    height: 2rem;
  }

  ${Hanger} {
    position: absolute;
    right: -3rem;
  }
`;
const PrivateStyles = css`
  --action-bar-background: var(--private-01);
`;
export const Component = withPrivacy(ActionBar, PrivateStyles);
